import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { stripLanguagePrefix, withLanguagePrefix } from '@/lib/locale';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const handleToggle = (nextLanguage: 'el' | 'en') => {
    const basePath = stripLanguagePrefix(location.pathname);
    const nextPath = withLanguagePrefix(basePath, nextLanguage);

    if (nextPath !== location.pathname) {
      navigate(nextPath);
      return;
    }

    if (language !== nextLanguage) {
      setLanguage(nextLanguage);
    }
  };

  return (
    <div className="flex items-center gap-1 rounded-full border border-white/15 bg-white/10 p-1 shadow-[0_0_0_1px_rgba(255,255,255,0.06)] backdrop-blur-sm">
      <button
        onClick={() => handleToggle('el')}
        aria-label="Αλλαγή γλώσσας σε Ελληνικά"
        className={`flex items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 ${
          language === 'el'
            ? 'bg-white text-black shadow-sm'
            : 'text-white/80 hover:bg-white/10 hover:text-white'
        }`}
      >
        ΕΛ
      </button>
      <button
        onClick={() => handleToggle('en')}
        aria-label="Switch language to English"
        className={`flex items-center justify-center rounded-full px-2.5 py-1 text-xs font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 ${
          language === 'en'
            ? 'bg-white text-black shadow-sm'
            : 'text-white/80 hover:bg-white/10 hover:text-white'
        }`}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageToggle;
